export { ExpenseByArticlesReport } from '@app/pages/Analytics/ExpenseByArticlesReport/ui';
